/* BloopTrend fixes 2026-10-13: delivery estimate dates + sticky Add to cart. */
(function () {
  function addBiz(d, n) { var x = new Date(d.getFullYear(), d.getMonth(), d.getDate()); while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; } return x; }
  function subBiz(d, n) { var x = new Date(d.getFullYear(), d.getMonth(), d.getDate()); while (n > 0) { x.setDate(x.getDate() - 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; } return x; }
  var fmt = function (d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); };
  function eta() {
    document.querySelectorAll('[data-bt-eta]').forEach(function (box) {
      var mn = parseInt(box.getAttribute('data-min'), 10), mx = parseInt(box.getAttribute('data-max'), 10);
      if (!(mn > 0 && mx >= mn && mx < 40)) return;
      var today = new Date();
      var r = box.querySelector('[data-bt-eta-range]');
      if (r) { r.textContent = 'Order today, estimated arrival ' + fmt(addBiz(today, mn + 1)) + ' to ' + fmt(addBiz(today, mx + 2)) + ' (1–2 business days processing plus delivery; business days are Mon to Fri).'; r.hidden = false; }
      /* Christmas: arrive by Dec 24 with the slowest estimate plus 2 business days for order processing. */
      var y = today.getFullYear(), xmas = new Date(y, 11, 24);
      var by = subBiz(xmas, mx + 2);
      var startShow = new Date(y, 9, 1);
      var x = box.querySelector('[data-bt-eta-xmas]');
      var t0 = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      if (x && t0 >= startShow && t0 <= by) { x.textContent = 'For Christmas delivery, we suggest ordering this item by ' + by.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }) + '.'; x.hidden = false; }
    });
  }
  function satc() {
    var bar = document.querySelector('[data-bt-satc]');
    if (!bar) return;
    var real = document.querySelector('product-info .product-form__submit, .product__info-container .product-form__submit');
    if (!real) return;
    var btn = bar.querySelector('[data-bt-satc-btn]'), priceEl = bar.querySelector('[data-bt-satc-price]');
    var mq = window.matchMedia('(max-width: 749px)');
    function update() {
      var r = real.getBoundingClientRect(), navH = 56 + 84;
      var inView = r.bottom > 0 && r.top < window.innerHeight - navH;
      var show = mq.matches && !inView && real.offsetParent !== null;
      bar.classList.toggle('is-visible', show); bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      btn.tabIndex = show ? 0 : -1; document.body.classList.toggle('bt-satc-on', show);
    }
    function sync() {
      btn.disabled = real.disabled || real.getAttribute('aria-disabled') === 'true';
      var lbl = real.querySelector('span'); if (lbl && lbl.textContent.trim()) btn.textContent = lbl.textContent.trim();
      var pc = document.querySelector('.product__info-container .price');
      if (pc && priceEl) { var p = pc.classList.contains('price--on-sale') ? pc.querySelector('.price__sale .price-item--sale') : pc.querySelector('.price__regular .price-item--regular'); if (p && p.textContent.trim()) priceEl.textContent = p.textContent.trim(); }
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    btn.addEventListener('click', function () { sync(); if (!btn.disabled) real.click(); });
    new MutationObserver(sync).observe(real, { attributes: true, childList: true, subtree: true });
    sync(); update();
  }
  function init() { eta(); satc(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* 2026-10-15c: body.bt-cart-open while the cart drawer is active (hides the Inbox chat bubble; see bt-fixes-1013.css). */
(function () {
  function sync() {
    var open = !!document.querySelector('cart-drawer.active');
    document.body.classList.toggle('bt-cart-open', open);
  }
  function watch() {
    sync();
    var d = document.querySelector('cart-drawer');
    var mo = new MutationObserver(sync);
    if (d) mo.observe(d, { attributes: true, attributeFilter: ['class'] });
    mo.observe(document.body, { attributes: true, attributeFilter: ['class'] }); /* overflow-hidden toggles on every open/close */
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
  document.addEventListener('cart:refresh', sync);
})();

/* 2026-10-16b: mobile menu drawer helper (pairs with the "Mobile menu = fixed full-viewport drawer" block in bt-fixes-1013.css).
   On open: measure header bottom -> --bt-menu-top, reset internal scroll to top, lock page scroll (html/body.bt-menu-open).
   On close: unlock and restore the page scroll position. */
(function () {
  var det, drawer, lockY = 0, locked = false;
  function headerBottom() {
    var h = document.querySelector('.section-header');
    var b = h ? h.getBoundingClientRect().bottom : 64;
    return Math.max(0, Math.round(b));
  }
  function setTop() {
    var t = headerBottom();
    document.documentElement.style.setProperty('--bt-menu-top', t + 'px');
    /* header scrolled out of view -> drawer top is 0 and the pinned close X is shown (2026-10-16d) */
    document.documentElement.classList.toggle('bt-menu-away', t <= 0);
  }
  function addX() {
    if (!drawer || drawer.querySelector('.bt-menu-x')) return;
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'bt-menu-x'; b.setAttribute('aria-label', 'Close menu');
    b.innerHTML = '<svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true" focusable="false"><path d="M3 3l12 12M15 3L3 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none"/></svg>';
    /* same close path as the header toggle: click the summary so Dawn's own handler runs */
    b.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var sm = det.querySelector('summary');
      if (sm) sm.click(); else det.removeAttribute('open');
    });
    drawer.insertBefore(b, drawer.firstChild);
  }
  function resetScroll() {
    if (!drawer) return;
    drawer.scrollTop = 0;
    var nav = drawer.querySelector('.menu-drawer__navigation-container');
    if (nav) nav.scrollTop = 0;
  }
  function lock() {
    if (locked) return;
    locked = true; lockY = window.pageYOffset;
    setTop();
    document.documentElement.classList.add('bt-menu-open');
    document.body.classList.add('bt-menu-open');
    resetScroll();
    requestAnimationFrame(function () { setTop(); resetScroll(); });
    setTimeout(resetScroll, 60);
  }
  function unlock() {
    if (!locked) return;
    locked = false;
    document.documentElement.classList.remove('bt-menu-open', 'bt-menu-away');
    document.body.classList.remove('bt-menu-open');
    if (Math.abs(window.pageYOffset - lockY) > 1) window.scrollTo(0, lockY);
  }
  function sync() {
    if (!det) return;
    if (det.hasAttribute('open') && window.innerWidth < 990) lock(); else unlock();
  }
  function init() {
    det = document.getElementById('Details-menu-drawer-container');
    if (!det) return;
    drawer = det.querySelector('.menu-drawer');
    addX();
    new MutationObserver(sync).observe(det, { attributes: true, attributeFilter: ['open', 'class'] });
    window.addEventListener('resize', function () { if (locked) { if (window.innerWidth >= 990) unlock(); else setTop(); } });
    /* block touch-scroll of the page behind the drawer (iOS ignores overflow:hidden on body in some builds) */
    document.addEventListener('touchmove', function (e) {
      if (locked && drawer && !drawer.contains(e.target)) e.preventDefault();
    }, { passive: false });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* 2026-10-17d: fade the mobile chat bubble while the last occasion tile label is in the bubble's band (home page only). */
(function () {
  function init() {
    var labels = document.querySelectorAll('.bt-occ__label');
    if (!labels.length || !('IntersectionObserver' in window)) return;
    var mq = window.matchMedia('(max-width: 749px)'), seen = new Set(), io;
    function build() {
      if (io) io.disconnect();
      seen.clear(); document.body.classList.remove('bt-chat-clear');
      if (!mq.matches) return;
      var band = 240, nav = 64, top = -Math.max(0, window.innerHeight - nav - band);
      io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) seen.add(e.target); else seen.delete(e.target); });
        document.body.classList.toggle('bt-chat-clear', seen.size > 0);
      }, { rootMargin: top + 'px 0px -' + nav + 'px 0px' });
      /* only labels in the right-hand column sit under the bubble */
      labels.forEach(function (l, i) { if (i % 2 === 1) io.observe(l); });
    }
    build();
    (mq.addEventListener ? mq.addEventListener.bind(mq, 'change') : mq.addListener.bind(mq))(build);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* 1017f B-002: Escape closes the mobile filter drawer (theme only listened for keyup inside the wrapper, focus is usually on the summary/page). */
(function () {
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var d = document.querySelector('.mobile-facets__disclosure[open]');
    if (!d) return;
    var s = d.querySelector('summary');
    if (s) { s.click(); }
  });
})();

/* 1017g B-012/B-004: add body.bt-scrolling while the page scrolls on phones (passive, rAF-free, 350ms idle timer). CSS fades the chat bubble only; no layout effect. */
(function () {
  var mq = window.matchMedia('(max-width: 749px)'), t = null, on = false;
  function off() { on = false; document.body.classList.remove('bt-scrolling'); }
  window.addEventListener('scroll', function () {
    if (!mq.matches) return;
    if (!on) { on = true; document.body.classList.add('bt-scrolling'); }
    clearTimeout(t); t = setTimeout(off, 350);
  }, { passive: true });
})();

/* 1017m Header state after bfcache/scroll restore (replaces 1017l). Computes .scrolled-past-header on .section-header from the real scroll position; keeps StickyHeader.currentScrollTop in sync; polls each frame up to 3s and stops only after scroll has been stable >=1s; never removes the class on a transient scroll 0 during the first 1.5s of a pageshow/back_forward restore; one extra pass on the first 'scroll' event after restore. Top-of-page state is untouched. No CSS changes. */
(function () {
  var polling = false, restoreAt = 0, scrollOnce = false;
  function isBack() {
    try { var n = performance.getEntriesByType('navigation')[0]; return !!n && n.type === 'back_forward'; } catch (e) { return false; }
  }
  if (isBack()) restoreAt = Date.now();
  function apply() {
    var header = document.querySelector('.section-header');
    if (!header) return 0;
    var el = document.querySelector('sticky-header');
    var st = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    var hb = (el && el.headerBounds && el.headerBounds.bottom) || header.offsetHeight || 0;
    var restoring = restoreAt && Date.now() - restoreAt < 1500;
    if (st > 0 && st > hb) header.classList.add('scrolled-past-header');
    else if (st <= 0 && !restoring) header.classList.remove('scrolled-past-header');
    if (el && !(st <= 0 && restoring)) el.currentScrollTop = st;
    return st;
  }
  function poll(fromRestore) {
    if (fromRestore === true) { restoreAt = Date.now(); scrollOnce = true; }
    apply();
    if (polling) return;
    polling = true;
    var start = Date.now(), last = -1, stableSince = Date.now();
    (function tick() {
      var st = apply(), now = Date.now();
      if (st !== last) { last = st; stableSince = now; }
      if (now - start < 3000 && !(now - stableSince >= 1000 && now - start >= 1000)) requestAnimationFrame(tick);
      else polling = false;
    })();
  }
  if (restoreAt) scrollOnce = true;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { poll(); }); else poll();
  window.addEventListener('load', function () { poll(); });
  window.addEventListener('pageshow', function (e) { poll(!!(e && e.persisted) || isBack()); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) poll(); });
  window.addEventListener('scroll', function () {
    if (!scrollOnce) return;
    scrollOnce = false;
    requestAnimationFrame(apply);
  }, { passive: true });
})();

/* 1017w: live bottom-nav cart badge. Root cause: bt-bottom-nav.js guards its pubsub subscribe with window.PUB_SUB_EVENTS, but constants.js declares it with top-level `const`, which is NOT a window property -> never subscribed. Here: subscribe via the global binding, plus cart:refresh, pageshow, and a fetch hook on /cart/add|change|update as fallback. */
(function () {
  var badge = document.querySelector('[data-bt-bnav-count]');
  var tab = document.querySelector('[data-bt-bnav-cart]');
  if (!badge || !tab) return;
  function setCount(n) {
    n = parseInt(n, 10) || 0;
    badge.textContent = n > 99 ? '99+' : String(n);
    badge.hidden = n === 0;
    tab.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
  }
  var inflight = null;
  function refresh() {
    if (inflight) clearTimeout(inflight);
    inflight = setTimeout(function () {
      inflight = null;
      var base = (window.routes && window.routes.cart_url) || '/cart';
      fetch(base.replace(/\/$/, '') + '.js?_=' + Date.now(), { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (c) { setCount(c.item_count); })
        .catch(function () {});
    }, 60);
  }
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
        if (ev && ev.cartData && typeof ev.cartData.item_count === 'number') setCount(ev.cartData.item_count);
        refresh();
      });
    }
  } catch (e) {}
  document.addEventListener('cart:refresh', refresh);
  window.addEventListener('pageshow', refresh);
  if (window.fetch && !window.__btCartFetchHook) {
    window.__btCartFetchHook = true;
    var of = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = of.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) p.then(refresh, function () {});
      return p;
    };
  }
})();

/* 1018m: body.bt-chat-ok (chat bubble allowed <750 only on /pages/* and /policies/*) and body.bt-banner-open (privacy banner visible). See bt-fixes-1013.css. */
(function () {
  var b = document.body;
  if (!b) return;
  var p = (location.pathname || '/').replace(/^\/[a-z]{2}(-[A-Za-z]{2,4})?(?=\/)/, '');
  var ok = /^\/(pages|policies)(\/|$)/.test(p) && !/^\/(collections|search|products|cart)(\/|$)/.test(p);
  b.classList.toggle('bt-chat-ok', ok);
  function vis(el) { return !!el && !el.hidden && el.getAttribute('hidden') === null && el.style.display !== 'none' && (el.offsetWidth || el.offsetHeight || el.getClientRects().length); }
  function sync() {
    var open = vis(document.getElementById('bt-privacy')) || vis(document.getElementById('shopify-pc__banner'));
    b.classList.toggle('bt-banner-open', !!open);
  }
  sync();
  var t;
  function later() { clearTimeout(t); t = setTimeout(sync, 30); }
  if (window.MutationObserver) {
    var mo = new MutationObserver(later);
    mo.observe(b, { childList: true });
    var el = document.getElementById('bt-privacy');
    if (el) mo.observe(el, { attributes: true, attributeFilter: ['hidden', 'style', 'class'] });
  }
  window.addEventListener('load', sync);
  document.addEventListener('bt:privacy-chosen', sync);
  setTimeout(sync, 1500); setTimeout(sync, 4000);
})();

/* 1018n-2: signed-in label. Liquid `customer` sets it server-side; for the Shop (shop-js) sign-in, customer is null, so detect the <shopify-account> signed-in state client-side. */
(function () {
  var wrap = document.querySelector('[data-bt-account-wrap]');
  if (!wrap) return;
  var label = wrap.querySelector('[data-bt-acct-label]');
  var host = wrap.querySelector('shopify-account');
  var mob = document.querySelector('[data-bt-acct-m]');
  var done = wrap.getAttribute('data-bt-logged-in') === 'true';
  function firstName(t) {
    t = (t || '').replace(/^\s*(hi|hello|welcome)[,!]?\s+/i, '').trim().split(/\s+/)[0] || '';
    return /^(sign|log|account|menu)/i.test(t) ? '' : t.replace(/[^\p{L}\p{N}'’-]/gu, '').slice(0, 30);
  }
  function detect() {
    if (!host) return null;
    var root = host.shadowRoot, name = '', signed = false;
    var attr = host.getAttribute('signed-in') || host.getAttribute('data-signed-in') || host.getAttribute('state');
    if (attr && /^(true|signed-?in)$/i.test(attr)) signed = true;
    if (root) {
      var av = root.querySelector('[part*="signed-in"], [class*="signed-in"], img[alt], [part*="avatar"] img, [part*="initial"]');
      var inn = root.querySelector('[part*="signed-in"], [class*="signed-in"]');
      if (inn) signed = true;
      if (av && !root.querySelector('slot[name="signed-out-avatar"]')) signed = true;
      var txt = '';
      if (av) txt = av.getAttribute('alt') || av.getAttribute('aria-label') || av.textContent || '';
      if (!txt) { var l = root.querySelector('[aria-label]'); if (l) txt = l.getAttribute('aria-label'); }
      name = firstName(txt);
    }
    return signed ? { name: name } : null;
  }
  function apply(r) {
    var n = r.name || '';
    if (label) { label.textContent = n || 'Account'; }
    wrap.setAttribute('data-bt-logged-in', 'true');
    var vh = host && host.querySelector('.visually-hidden'); if (vh) vh.textContent = n ? 'Account: ' + n : 'Account';
    if (mob) {
      mob.setAttribute('data-bt-logged-in', 'true');
      var ini = mob.querySelector('.bt-acct-m-initial');
      if (ini) ini.textContent = n ? n.charAt(0).toUpperCase() : '';
      if (!n && ini) { ini.textContent = ''; mob.setAttribute('data-bt-logged-in', 'false'); }
      mob.setAttribute('aria-label', n ? 'Account: ' + n : 'Account'); mob.title = n || 'Account';
    }
  }
  function check() {
    if (done) return;
    var r = detect();
    if (r) { done = true; apply(r); }
  }
  setTimeout(check, 800); setTimeout(check, 2500); setTimeout(check, 6000);
  window.addEventListener('load', check);
  if (host && window.MutationObserver) new MutationObserver(check).observe(host, { childList: true, attributes: true, subtree: true });
})();

/* 1018s fix 2: /policies/refund-policy and /policies/shipping-policy: hide a plain first line that repeats the page H1. */
(function () {
  if (!/^\/policies\//.test(location.pathname)) return;
  function norm(s) { return (s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }
  function run() {
    var h1 = document.querySelector('main h1, .shopify-policy__title h1, h1');
    if (!h1) return;
    var t = norm(h1.textContent);
    var body = document.querySelector('.shopify-policy__body, .shopify-policy__container, main');
    if (!body || !t) return;
    var els = body.querySelectorAll('p, div, h2, h3, h4, strong, span');
    for (var i = 0; i < els.length && i < 6; i++) {
      var e = els[i];
      if (e.contains(h1) || h1.contains(e) || e.children.length > 1) continue;
      if (norm(e.textContent) === t) { e.style.display = 'none'; e.setAttribute('data-bt-dup-title', ''); break; }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* 1018s fix 3: /policies/terms-of-service: make "SECTION n - TITLE" runs separate heading lines. Text unchanged. */
(function () {
  if (!/^\/policies\/terms-of-service/.test(location.pathname)) return;
  var re = /SECTION\s+\d+\s*[-\u2013\u2014]\s*(?:[A-Z0-9,&'\/()\u2019.-]+(?=\s|$)\s?)+/;
  function run() {
    var root = document.querySelector('.shopify-policy__body, .shopify-policy__container, main');
    if (!root) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), nodes = [], n;
    while ((n = w.nextNode())) { if (re.test(n.nodeValue) && !(n.parentNode.closest && n.parentNode.closest('.bt-terms-h, h1, h2, h3, h4'))) nodes.push(n); }
    nodes.forEach(function (tn) {
      var m = re.exec(tn.nodeValue); if (!m) return;
      var before = tn.nodeValue.slice(0, m.index), head = m[0].replace(/\s+$/, ''), after = tn.nodeValue.slice(m.index + m[0].length);
      var h = document.createElement('span'); h.className = 'bt-terms-h'; h.setAttribute('role', 'heading'); h.setAttribute('aria-level', '2'); h.textContent = head;
      var par = tn.parentNode;
      par.insertBefore(document.createTextNode(before), tn);
      par.insertBefore(h, tn);
      tn.nodeValue = after.replace(/^\s+/, '');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* 1019lb: body.bt-lb-open while a product image lightbox (<product-modal>) is open, so bt-fixes-1013.css can hide the sticky ATC bar, bottom nav, Inbox launcher and privacy banner; removed on close. */
(function () {
  function sync() { document.body && document.body.classList.toggle('bt-lb-open', !!document.querySelector('product-modal[open]')); }
  function init() {
    var mods = document.querySelectorAll('product-modal');
    if (!mods.length || !window.MutationObserver) return;
    var mo = new MutationObserver(sync);
    mods.forEach(function (m) { mo.observe(m, { attributes: true, attributeFilter: ['open'] }); });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
